import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { routeTree } from "./routeTree.gen";

// Design tokens SoT — primitives + semantics + .dark overrides + body rules.
// Must load BEFORE local globals.css so app-level layer additions can override.
import "@modootoday/ui-tokens/globals.css";
// Pretendard Variable — self-hosted dynamic subset (≤100 KB gzipped), CSP-safe.
// Resolves the `font-family: "Pretendard Variable", ...` stack set in ui-tokens.
import "pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css";

import "./globals.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
